import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { AddLikeDislikeUseCase } from './AddLikeDislikeUseCase';
import { GetContentRatingUseCase } from './GetContentRatingUseCase';
import { LearnEventUseCase } from './LearnEventUseCase';
import { SearchClickActionUseCase } from './SearchClickActionUseCase';
import { SetPreferencesActionUseCase } from './SetPreferencesActionUseCase';
import { log } from '@intigral/utils/lib/logger';

export const initializeLearnActionUseCases = (container: Container) => {
    container.register(DI.USECASES.IAddLikeDislikeUseCase, {
        useClass: AddLikeDislikeUseCase,
    });
    container.register(DI.USECASES.IGetContentRatingUseCase, {
        useClass: GetContentRatingUseCase,
    });
    container.register(DI.USECASES.ILearnEventUseCase, {
        useClass: LearnEventUseCase,
    });
    container.register(DI.USECASES.ISearchClickActionUseCase, {
        useClass: SearchClickActionUseCase,
    });
    container.register(DI.USECASES.ISetPreferencesActionUseCase, {
        useClass: SetPreferencesActionUseCase,
    });
};
